
import ScorePlot from '@/components/vis/ScorePlot.vue';
import VisTile from '@/components/vis/VisTile.vue';
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  components: {
    ScorePlot,
    VisTile,
  },
  props: {
    pcX: {
      type: Number,
      required: true,
    },
    pcY: {
      type: Number,
      required: true,
    },
    showEllipses: {
      type: Boolean,
      required: true,
    },
    pcCoords: {
      type: Array,
      required: true,
    },
    rowLabels: {
      type: Array,
      required: true,
    },
    groupLabels: {
      type: Object,
      required: true,
    },
    groupLevels: {
      type: Array,
      required: true,
    },
    eigenvalues: {
      type: Array,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
  },
});
